export default __webpack_public_path__ + "static/media/slide5.48a2eef5.png";